import { getEnv } from 'infra/config/env'

/**
 * Verifica se o novo fluxo de criação do pedido cirúrgico (gabarito OPME) deve
 * ser exibido para todos os médicos.
 *
 * Controlado pela env var `REACT_APP_GABARITO_OPME_DOCTORS_ENABLED`, que aceita
 * um valor booleano em texto (ex.: `true`/`false`). A comparação é
 * case-insensitive e tolerante a espaços.
 *
 * Quando ativa (`true`), todos os médicos são direcionados ao novo fluxo
 * (`/pedido`). Quando inativa (`false`), todos são direcionados ao fluxo antigo
 * (`/novo-pedido/local`) — permitindo pivotar o rollout sem novo deploy.
 *
 * Esta flag é temporária, usada durante o período de adaptação ao novo fluxo.
 *
 * Retorna `false` quando a var não está definida ou possui qualquer valor
 * diferente de `true`, garantindo que o fluxo antigo permaneça como fallback.
 */
export const isOpmeGabaritoEnabled = (): boolean =>
  getEnv('REACT_APP_GABARITO_OPME_DOCTORS_ENABLED').trim().toLowerCase() ===
  'true'

/**
 * Verifica se o modal de aviso de manutenção deve ser exibido.
 *
 * Controlado pela env var `REACT_APP_MAINTENANCE_NOTICE_ENABLED`, que aceita
 * um valor booleano em texto (ex.: `true`/`false`). A comparação é
 * case-insensitive e tolerante a espaços.
 *
 * Retorna `false` quando a var não está definida ou possui qualquer valor
 * diferente de `true`, garantindo que o modal fique oculto por padrão.
 */
export const isMaintenanceNoticeEnabled = (): boolean =>
  getEnv('REACT_APP_MAINTENANCE_NOTICE_ENABLED').trim().toLowerCase() === 'true'

/**
 * Verifica se o bloqueio geral de acesso à aplicação deve ser ativado.
 *
 * Controlado pela env var `REACT_APP_MAINTENANCE_ACCESS_BLOCK`, que aceita
 * um valor booleano em texto (ex.: `true`/`false`). A comparação é
 * case-insensitive e tolerante a espaços.
 *
 * Quando ativa, o usuário fica impedido de realizar login e de acessar
 * qualquer rota da aplicação, sendo direcionado à tela informativa de
 * indisponibilidade.
 *
 * Retorna `false` quando a var não está definida ou possui qualquer valor
 * diferente de `true`, garantindo que o acesso permaneça liberado por padrão.
 */
export const isMaintenanceAccessBlockEnabled = (): boolean =>
  getEnv('REACT_APP_MAINTENANCE_ACCESS_BLOCK').trim().toLowerCase() === 'true'

/**
 * Verifica se os cards informativos de restabelecimento do sistema devem ser
 * exibidos.
 *
 * Controlado pela env var `REACT_APP_MAINTENANCE_RECOVERY_ENABLED`, que aceita
 * um valor booleano em texto (ex.: `true`/`false`). A comparação é
 * case-insensitive e tolerante a espaços.
 *
 * Quando ativa, os cards de aviso de restabelecimento (ex.: no topo da tela de
 * login) ficam visíveis, comunicando que o sistema voltou a operar e que
 * instabilidades pontuais podem ocorrer durante a estabilização.
 *
 * Retorna `false` quando a var não está definida ou possui qualquer valor
 * diferente de `true`, garantindo que os cards fiquem ocultos por padrão.
 */
export const isMaintenanceRecoveryEnabled = (): boolean =>
  getEnv('REACT_APP_MAINTENANCE_RECOVERY_ENABLED').trim().toLowerCase() ===
  'true'
